import type { ITitleTheme } from '@visactor/vchart';

export const title: ITitleTheme = {
  padding: {
    top: 4,
    bottom: 20
  }
};
